import * as React from 'react';
import { ProfileDropdown } from '@ghq-abi/design-system';

import type { User } from '~/app/contexts/UserContext';

import { useUserDropdown } from './hooks';

type UserDropdownProps = {
  user: User;
};
export function UserDropdown({ user }: UserDropdownProps) {
  const { items, profileInfo } = useUserDropdown(user);

  return <ProfileDropdown items={items} profileInfo={profileInfo} />;
}
